import RemittanceLines from '../../../../../components/Purchasing/Remittance/AddRemittance/Lines/RemittanceLines'
import React from 'react'

function RemittanceLinesCont (props) {
  const { remittance } = props

  return (
    <RemittanceLines
      {
        ...{
          // list,
          // fetching,
          // fetch,
          // visible,
          // submitting,
          // remittance,
          // line,
          // onShow,
          // onCancel,
          // submit,
          // removing,
          // remove,
          // update,
          // modalType,
          // formRef,
        }
      }
    />
  )
}

RemittanceLinesCont.propTypes = {}
RemittanceLinesCont.defaultProps = {}

export default (RemittanceLinesCont)
